module.exports = __webpack_public_path__ + "img/AI房屋投資小精靈.dd9f7495.jpg";